import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { documentsTypes } from "../constantes/actionTypes"

export const typesOfDocumentsActions = {
    getAllTypesOfDocuments: () => (
        createMiddlewareAction({
            successType: documentsTypes.GET_ALL_TYPE_OF_DOCUMENTS_SUCCESS,
            failureType: documentsTypes.GET_ALL__TYPE_OF_DOCUMENTS_FAILURE,
            method: "GET",
            endpoint: endpoints.GET_ALL_TYPE_OF_DOCUMENTS
        })
    ),
}